import {
    HStack, VStack, Image
} from '@chakra-ui/react';
import { t } from '@lingui/macro';
import React from 'react';
import { useDispatch } from 'react-redux';

import portalCommunication from '../../../../services/mathletics-portal-communication-service';
import { closeModal } from '../../../modal-manager';
import Close from './assets/close.svg';
import * as styled from './try-new-course-modal.styled';

type TryNewCourseModalProps = {
    heading?: string
    subHeading?: string
    background: string
    showNewBadge?: boolean
    classId?: string
    groupId?: string
    redirectToModuleId?: number
    clickHandler?: () => void
};

export function TryNewCourseModal ({
    heading = '',
    subHeading = '',
    background,
    classId = '0',
    groupId = '0',
    redirectToModuleId,
    clickHandler
}: TryNewCourseModalProps) {
    const dispatch = useDispatch();
    const closeModalClick = () => {
        dispatch(closeModal());
    };
    const handleTryItNowClick = () => {
        portalCommunication.postPortalMessage({
            type: portalCommunication.MESSAGES.SET_CURRENT_CLASS_GROUP,
            params: {
                classId,
                groupId
            }
        });
        if (clickHandler) clickHandler();

        portalCommunication.postPortalMessage({
            type: portalCommunication.MESSAGES.MODULE_CHANGE,
            message: redirectToModuleId
        });
        closeModalClick();
    };

    return (
        <styled.wrapper>
            <styled.closeButton onClick={closeModalClick}>
                <Image src={Close} minW={'14px'} />
            </styled.closeButton>
            <styled.container backgroundImage={background}>
                <VStack gap={'10px'} mt={'20px'}>
                    <styled.heading>{heading}
                    </styled.heading>
                </VStack>
                <styled.subheading>
                    {subHeading}
                </styled.subheading>
            </styled.container>
            <styled.footer>
                <HStack mr={'20px'}>
                    <styled.buttonSecondary onClick={closeModalClick}>{t`tryNewCourseModal.later`}</styled.buttonSecondary>
                    <styled.buttonPrimary onClick={handleTryItNowClick}>{t`tryNewCourseModal.tryItNow`}</styled.buttonPrimary>
                </HStack>
            </styled.footer>
        </styled.wrapper>
    );
}

